<template>
  <div style="padding: 5px;">
    <a-card>
      <div style="text-align: right;">
        <span
          class="ant-descriptions-title"
          style="float: left; margin-top: 5px;"
        >
          <a-icon type="tags" /> List Vehicle
        </span>
        <a-input
          placeholder="Search..."
          style="width: 350px; max-width: 100%; margin-right: 5px;"
          @change="onFilter"
          v-model="filter.query"
        />
        <a-button
          style="margin-right: 5px;"
          :loading="loadingList"
          icon="sync"
          @click="onGetAllVehicle"
        >
          Sync
        </a-button>
        <FilterListDrawer style="margin-right: 5px;" :filterList="filterList" />
        <a-button
          slot="extra"
          type="primary"
          @click="() => (visibleAdd = true)"
        >
          <a-icon type="plus" /> Add New
        </a-button>
      </div>

      <a-table
        :columns="columnsAllVehicle"
        :data-source="holidays"
        size="small"
        :loading="loadingList"
        rowKey="id"
        :pagination="{
          current: currentPage,
          onChange: (page) => {
            this.currentPage = page;
          },
          pageSize: limit,
        }"
      >
        <div slot="footer">
          <a-button
            :loading="loadingList"
            type="link"
            @click="onPagination"
            :disabled="!isPagination"
          >
            <a-icon type="reload" /> Load more
          </a-button>
        </div>
        <div slot="stt" slot-scope="text, record, index">
          {{ index + 1 }}
        </div>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="createdAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="updatedAt" slot-scope="text">
          {{ text | formatDateHour }}
        </span>
        <span slot="action" style="float: right;" slot-scope="text, record">
          <a-button @click="collapseVisibleEdit(record.id)">
            <a-icon title="Chỉnh sửa" type="edit" /> Edit
          </a-button>
        </span>
      </a-table>

      <a-drawer
        v-if="visibleEdit"
        title="Edit"
        placement="right"
        :visible="visibleEdit"
        @close="() => (visibleEdit = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <EditVehicle
          :idVehicle="idVehicle"
          :close="() => (visibleEdit = false)"
          :refreshAfterUpdated="refreshAfterUpdated"
          :refreshAfterDeleted="refreshAfterDeleted"
        />
      </a-drawer>

      <a-drawer
        v-if="visibleAdd"
        title="Add New"
        placement="right"
        :visible="visibleAdd"
        @close="() => (visibleAdd = false)"
        :width="450"
        :bodyStyle="{ height: 'calc(100% - 100px)', overflowY: 'auto' }"
      >
        <AddVehicle
          :close="() => (visibleAdd = false)"
          :refreshAfterCreated="refreshAfterCreated"
        />
      </a-drawer>
    </a-card>
  </div>
</template>
<script>
import { columnsAllVehicle } from "./constant/column";
import AddVehicle from "./components/addVehicle";
import EditVehicle from "./components/editVehicle";
import query from "./constant/query";
import {
  updateForCreated,
  updateForUpdated,
  updateForDeleted,
} from "@/services/updateOnViewConfig";
import debounce from "lodash/debounce";
const limit = 10;
const startPage = 1;

const defaultFilter = { query: "" };
function range(start, end) {
  var ans = [];

  for (let i = start; i <= end; i++) {
    ans.push(i);
  }
  return ans;
}

export default {
  components: {
    AddVehicle,
    EditVehicle,
    FilterListDrawer: () => import("./components/filter-list.drawer.vue"),
  },
  data() {
    this.onFilter = debounce(this.onFilter, 500);
    return {
      limit,
      visibleEdit: false,
      visibleDetail: false,
      visibleAdd: false,
      columnsAllVehicle,
      loadingList: true,
      holidays: [],
      idVehicle: "",
      filter: defaultFilter,
      currentPage: startPage,
      totalPage: startPage,
      isPagination: true,
    };
  },
  methods: {
    onGetAllVehicle(flag) {
      this.loadingList = true;
      this.$apollo
        .query({
          query: query.getListVehicle,
          fetchPolicy: "no-cache",
          variables: {
            limit,
            page: this.totalPage,
            ...this.filter,
          },
        })
        .then(({ data }) => {
          this.loadingList = false;
          if (data?.getListVehicle?.length >= 0) {
            if (flag === "FILTER") {
              this.holidays = [...data.getListVehicle];
            } else if (flag === "PAGINATION") {
              this.holidays = this.holidays.concat([...data.getListVehicle]);
            } else {
              this.holidays = [...data.getListVehicle];
            }
            // check is pagniation
            if (data.getListVehicle.length < limit) {
              this.isPagination = false;
            } else {
              this.isPagination = true;
            }
          }
        })
        .catch((err) => {
          this.$notification.error({
            message: "Error",
            description: "Get Item Error!",
          });
          console.log("Lấy danh sách ngày nghỉ lễ không thành công", err);
        });
    },
    collapseVisibleDetail(id) {
      if (id) {
        this.idVehicle = id;
        this.visibleDetail = true;
      } else {
        this.idVehicle = "";
        this.visibleDetail = false;
      }
    },
    collapseVisibleEdit(id) {
      if (id) {
        this.idVehicle = id;
        this.visibleEdit = true;
      } else {
        this.idVehicle = "";
        this.visibleEdit = false;
      }
    },
    onFilter() {
      this.currentPage = startPage;
      this.totalPage = startPage;
      this.onGetAllVehicle("FILTER");
    },
    refreshAfterUpdated(item) {
      this.holidays = updateForUpdated(this.holidays, item);
    },
    refreshAfterDeleted(item) {
      this.holidays = updateForDeleted(this.holidays, item);
    },
    refreshAfterCreated(item) {
      this.holidays = updateForCreated({
        list: this.holidays,
        item,
        limit,
        currentPage: this.currentPage,
      });
    },
    onPagination() {
      if (this.isPagination) {
        this.totalPage += 1;
        this.currentPage = this.totalPage;
        this.onGetAllVehicle("PAGINATION");
      }
    },
    filterList(filter) {
      this.filter = filter ? { ...this.filter, ...filter } : this.filter;
      this.onFilter();
    },
  },
  created() {
    this.onGetAllVehicle();
  },
};
</script>
<style lang="css" scoped></style>
